import { Component, Input, ViewChild, inject } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';
import { Authentication } from 'src/app/core/authentication';
import { LogifitCachedProfilesListComponent } from 'src/app/components/logifit-cached-profiles-list/logifit-cached-profiles-list.component';
import { CachedProfilesService } from 'src/app/services/cached-profiles.service';

@Component({
  selector: 'app-logifit-modal-account-wisselen',
  templateUrl: './logifit-modal-account-wisselen.component.html',
  styleUrls: ['./logifit-modal-account-wisselen.component.scss']
})
export class LogifitModalAccountWisselenComponent {

  @Input() triggerStyle: 'profile' | 'menu' = 'profile';
  @Input() triggerId = 'open-modal-account-wisselen';

  @ViewChild('modal') modal: IonModal;
  @ViewChild('profileList') profileList: LogifitCachedProfilesListComponent;

  private cachedProfilesService = inject(CachedProfilesService);

  constructor(private userService: UserService) { }

  public onModalWillPresent() {
    this.profileList?.refreshProfiles();
  }

  public async login(username: string, password: string): Promise<void> {
    Authentication.Logout();
    this.userService.login(username, password).subscribe(async (result: boolean) => {
      if (result) {
        this.cachedProfilesService.saveCurrentUser();
        if (this.modal) {
          await this.modal.dismiss();
          window.location.reload();
        }
      }
    });
  }

  public logout(): void {
    this.cachedProfilesService.preferLoginFormOnNextVisit();
    this.userService.logout();
  }

}
